module.exports = __webpack_public_path__ + "img/logo5-blue-white.8a998ee1.svg";